module.exports = __webpack_public_path__ + "img/ic_mail.650197f6.svg";